<script>
import { Validator } from 'vee-validate'
import i18n from '../constants/lang/i18n'

export default {
  data () {
    return {
      locale: i18n.locale
    }
  },
  computed: {
    // static
    languageOptions () {
      return [
        {
          title: '繁體中文',
          value: 'tc'
        },
        {
          title: 'English',
          value: 'en'
        }
      ]
    }
  },
  methods: {
    setLang (locale) {
      i18n.locale = locale
      Validator.localize(locale)
      localStorage.setItem('locale', locale)
      this.locale = locale
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/locale.vue